module.exports = __webpack_public_path__ + "static/media/Button_341px.ebc51b37.svg";